import { system } from "../conf";

export const baseUrl = system.api;
